


const CustomAggFuncs = {

    severitySummary: function(values) {
        let C = 0;
        let M = 0;
        let m = 0;
        let O = 0;
        let I = 0;
        for(let value of values) {
            console.log(value);
            switch(value) {
                case 'CRITICAL':
                    C++;
                    break;
                case 'MAJOR':
                    M++;
                    break;
                case 'MINOR':
                    m++;
                    break;
                case 'OBSERVATIONAL':
                    O++;
                    break;
                default:
                    I++;
                    break;
            }
        }
        return `C(${C}) M(${M}) m(${m}) O(${O})`;
    },

    maxSeverity: function(values) {
        if(values.some(v => {return v == 'CRITICAL'})) {
            return 'CRITICAL';
        }
        else if(values.some(v => {return v == 'MAJOR'})) {
            return 'MAJOR';
        }
        else if(values.some(v => {return v == 'MINOR'})) {
            return 'MINOR';
        }
        else if(values.some(v => {return v == 'OBSERVATIONAL'})) {
            return 'OBSERVATIONAL';
        }
        else {
            return 'INDETERMINATE';
        }
    },

    minSeverity: function(values) {
        if(values.some(v => {return v == 'OBSERVATIONAL'})) {
            return 'OBSERVATIONAL';
        }
        else if(values.some(v => {return v == 'MINOR'})) {
            return 'MINOR';
        }
        else if(values.some(v => {return v == 'MAJOR'})) {
            return 'MAJOR';
        }
        else if(values.some(v => {return v == 'CRITICAL'})) {
            return 'CRITICAL';
        }
        else {
            return 'INDETERMINATE';
        }
    },

    newestDate: function(values) {
        let unixTimes = values.map(v => {
            return TELSA.moment(v).unix();
        });
        let ans = Math.max(...unixTimes);
        return TELSA.moment.unix(ans).format("YYYY-MM-DD HH:mm:ss");
    },

    oldestDate: function(values) {
        let unixTimes = values.map(v => {
            return TELSA.moment(v).unix();
        });
        let ans = Math.min(...unixTimes);
        return TELSA.moment.unix(ans).format("YYYY-MM-DD HH:mm:ss");
    },

    yesCount: function(values) {
        let count = 0;
        for(let value of values) {
            if(Number.isInteger(value)) {
                count += value;
            }
            else if(typeof value == 'string' && value.toLowerCase() == 'yes') {
                count++;
            }
        }
        return count;
    }

};

const alarmSeverityTypes = ['OBSERVATIONAL', 'MINOR', 'MAJOR', 'CRITICAL'];
const rowColorFuncs = {

    getRowColor: function(row, alarmColors) {
        let alarmStatus = (row.data.alarm_clear_time.length ? 'cleared' : (row.data.alarm_ack_time.length ? 'acked' : 'new'));

        // If the alarm doesn't have a supported severity then use default(black on white)
        if(!alarmSeverityTypes.includes(row.data.alarm_severity.toUpperCase())) {
            return {background: '#ffffff', color: '#000000'};
        }
        return { 
            background: alarmColors[row.data.alarm_severity.toLowerCase()][alarmStatus].background,
            color: alarmColors[row.data.alarm_severity.toLowerCase()][alarmStatus].foreground,
            fontWeight: row.data.children && row.data.children.length ? 'bold' : '',
            fontSize: row.data.children && row.data.children.length ? '16px' : '12px'
        };
    },

    getGroupRowColor: function(leafRows, alarmColors) {
        const sevEnum = Object.freeze({'OBSERVATIONAL': 1, 'MINOR': 2, 'MAJOR': 3, 'CRITICAL': 4});
        const statusEnum = Object.freeze({'CLEARED': 1, 'ACKED': 2, 'NEW': 3});
        let highSevScore = 0;
        for(let row of leafRows) {
            let statusScore = (row.data.alarm_clear_time.length ? 1 : (row.data.alarm_ack_time.length ? 2 : 3));
            let severityScore = (!alarmSeverityTypes.includes(row.data.alarm_severity.toUpperCase()) ? 0 : sevEnum[row.data.alarm_severity])
            let score = parseInt(`${severityScore}${statusScore}`);
            if(score == 43) {
                highSevScore = 43; // highest critical state acheived, so no need to do any more.
                break;
            }
            if(score > highSevScore) {
                highSevScore = score;
            }
        }
        highSevScore = highSevScore.toString();
        if(highSevScore < 10) {
            return {background: '#ffffff', color: '#000000'};
        }
        let sevEnumIdx = (parseInt(highSevScore[0]) - 1);
        let statusEnumIdx = (parseInt(highSevScore[1]) - 1);
        let colorObj = alarmColors[Object.keys(sevEnum)[sevEnumIdx].toLowerCase()][Object.keys(statusEnum)[statusEnumIdx].toLowerCase()];
        return {
            background: colorObj.background,
            color: colorObj.foreground
        };
    },

    getIssueRowColor: function(row, alarmColors) {
        // let alarmStatus = (row.data.alarm_clear_time.length ? 'cleared' : (row.data.alarm_ack_time.length ? 'acked' : 'new'));
        let alarmStatus = 'new';

        // If the alarm doesn't have a supported severity then use default(black on white)
        if(!alarmSeverityTypes.includes(row.data.issue_severity.toUpperCase())) {
            return {background: '#ffffff', color: '#000000'};
        }
        return { 
            background: alarmColors[row.data.issue_severity.toLowerCase()][alarmStatus].background,
            color: alarmColors[row.data.issue_severity.toLowerCase()][alarmStatus].foreground,
        };
    },

    getIssueGroupRowColor: function(leafRows, alarmColors) {
        const sevEnum = Object.freeze({'OBSERVATIONAL': 1, 'MINOR': 2, 'MAJOR': 3, 'CRITICAL': 4});
        let highSevScore = 0;
        for(let row of leafRows) {
            let severityScore = (!alarmSeverityTypes.includes(row.data.issue_severity.toUpperCase()) ? 0 : sevEnum[row.data.issue_severity])
            if(severityScore == 4) {
                highSevScore = 4; // highest critical state acheived, so no need to do any more.
                break;
            }
            if(severityScore > highSevScore) {
                highSevScore = severityScore;
            }
        }
        //highSevScore = highSevScore.toString();
        if(highSevScore < 1) {
            return {background: '#ffffff', color: '#000000'};
        }
        let sevEnumIdx = (parseInt(highSevScore) - 1);
        let colorObj = alarmColors[Object.keys(sevEnum)[sevEnumIdx].toLowerCase()]['new'];
        return {
            background: colorObj.background,
            color: colorObj.foreground
        };

    }

};


const alarmPipeFilterParams = {
    suppressAndOrCondition: true,
    textCustomComparator: function(filter, value, filterText) {
        let filterTexts = filterText.split('|');
        filterTexts = filterTexts.map(f => {return f.toLowerCase().trim()});
        let valueLowerCase = value.toString().toLowerCase();
        switch (filter) {
            case 'contains':
                return filterTexts.some(filterTextLowerCase => {return valueLowerCase.indexOf(filterTextLowerCase) >= 0;});
            case 'notContains':
                return filterTexts.every(filterTextLowerCase => {return valueLowerCase.indexOf(filterTextLowerCase) === -1;});
            case 'equals':
                return filterTexts.some(filterTextLowerCase => {return valueLowerCase === filterTextLowerCase;});
            case 'notEqual':
                return filterTexts.every(filterTextLowerCase => {return valueLowerCase != filterTextLowerCase;});
            case 'startsWith':
                return filterTexts.some(filterTextLowerCase => {return valueLowerCase.indexOf(filterTextLowerCase) === 0;});
            case 'endsWith':
                return filterTexts.some(filterTextLowerCase => {
                    let index = valueLowerCase.lastIndexOf(filterTextLowerCase);
                    return index >= 0 && index === (valueLowerCase.length - filterTextLowerCase.length);
                });
            default:
                // should never happen
                console.warn('invalid filter type ' + filter);
                return false;
        }
    },
};


const alarmDateFilterParams = {
    buttons: ['clear'],
    suppressAndOrCondition: true,
    filterOptions: ['greaterThan', 'lessThan', 'inRange'],
    comparator: function(selectedDateMidnight, value) {
        let d = TELSA.moment(selectedDateMidnight);
        let v = TELSA.moment(value);
        if(v < d) {
            return -1;
        }
        else if(v > d) {
            return 1;
        }
        else {
            return 0;
        }
    }
};



export { CustomAggFuncs, rowColorFuncs, alarmPipeFilterParams, alarmDateFilterParams };


